import { arrayIncludes } from '../../utils/array';
export var findClosestEnabledDate = function findClosestEnabledDate(_ref) {
  var date = _ref.date,
    utils = _ref.utils,
    minDate = _ref.minDate,
    maxDate = _ref.maxDate,
    disableFuture = _ref.disableFuture,
    disablePast = _ref.disablePast,
    shouldDisableDate = _ref.shouldDisableDate;
  var today = utils.startOfDay(utils.date());
  if (disablePast && utils.isBefore(minDate, today)) {
    // eslint-disable-next-line no-param-reassign
    minDate = today;
  }
  if (disableFuture && utils.isAfter(maxDate, today)) {
    // eslint-disable-next-line no-param-reassign
    maxDate = today;
  }
  var forward = date;
  var backward = date;
  if (utils.isBefore(date, minDate)) {
    forward = utils.date(minDate);
    backward = null;
  }
  if (utils.isAfter(date, maxDate)) {
    if (backward) {
      backward = utils.date(maxDate);
    }
    forward = null;
  }
  while (forward || backward) {
    if (forward && utils.isAfter(forward, maxDate)) {
      forward = null;
    }
    if (backward && utils.isBefore(backward, minDate)) {
      backward = null;
    }
    if (forward) {
      if (!shouldDisableDate(forward)) {
        return forward;
      }
      forward = utils.addDays(forward, 1);
    }
    if (backward) {
      if (!shouldDisableDate(backward)) {
        return backward;
      }
      backward = utils.addDays(backward, -1);
    }
  }
  return null;
};
export var isYearOnlyView = function isYearOnlyView(views) {
  return views.length === 1 && views[0] === 'year';
};
export var isYearAndMonthViews = function isYearAndMonthViews(views) {
  return views.length === 2 && arrayIncludes(views, 'month') && arrayIncludes(views, 'year');
};
export var getFormatByViews = function getFormatByViews(views, utils) {
  if (isYearOnlyView(views)) {
    return utils.getOptions().yearFormat;
  }
  if (isYearAndMonthViews(views)) {
    return utils.getOptions().yearMonthFormat;
  }
  return utils.getOptions().dateFormat;
};